// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"m6-z","colorTextValue":"n6-z","swatches":"o6-z","collapseLink":"p6-z","isCollapsed":"q6-z","dropdown":"r6-z","disabled":"s6-z"};